/* Le Sicilianedde – parallasse, comparse allo scroll, briciole al click */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = function () { return window.innerWidth >= 750; };

  /* 1. comparsa degli elementi allo scroll */
  function reveal() {
    var sel = '.sic-sechead,.sic-card,.sic-featcard,.sic-review,.sic-timeline__item,.sic-place__intro,.sic-place__art,.sic-place__card,.sic-place__map,.sic-serv__col,.sic-feat,.sic-about__intro,.sic-loc__intro,.sic-loc__what,.sic-loc__soon>div,.sic-footer__grid>div,.sic-hero__content';
    var els = document.querySelectorAll(sel), fades = document.querySelectorAll('.sic-box,.sic-collage img');
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el, i) { if (el.classList.contains('sic-reveal')) return; el.classList.add('sic-reveal'); el.style.transitionDelay = ((i % 4) * 90) + 'ms'; io.observe(el); });
    fades.forEach(function (el) { el.classList.add('sic-fade'); io.observe(el); });
  }

  /* 2. parallasse: i tasselli di "Chi siamo" e i disegni si muovono a velocità diverse */
  var par = [
    ['.sic-about .sic-doodle', .3], ['.sic-locs .sic-doodle', -.25]
  ], items = [];
  function collect() {
    items = [];
    par.forEach(function (p) { document.querySelectorAll(p[0]).forEach(function (el, i) { items.push([el, p[1] * (i % 2 ? -1 : 1) * (1 + (i % 3) * .2), 0]); }); });
    /* quadretti: velocità e rotazione proprie, scritte nel markup */
    document.querySelectorAll('[data-par]').forEach(function (el) { items.push([el, parseFloat(el.getAttribute('data-par')) || 0, parseFloat(el.getAttribute('data-rot')) || 0]); });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var mob = !desktop(), amp = mob ? .45 : 1, lim = mob ? 34 : 90;
      var vh = window.innerHeight;
      items.forEach(function (it) {
        var r = it[0].getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var c = Math.max(-vh * .5, Math.min(vh * .5, r.top + r.height / 2 - vh / 2));
        if (mob && it[0].classList.contains('sic-doodle')) return;
        var t = Math.max(-lim, Math.min(lim, c * -it[1] * amp));
        it[0].style.translate = '0 ' + t.toFixed(1) + 'px';
        if (it[2]) { var k = Math.max(-1, Math.min(1, c / vh)); it[0].style.rotate = (it[2] * (.35 + k) * (mob ? .8 : 1)).toFixed(2) + 'deg'; }
      });
    });
  }

  /* 3. i disegnini dell'hero seguono il mouse */
  function heroMouse() {
    var hero = document.querySelector('.sic-hero'); if (!hero) return;
    var imgs = hero.querySelectorAll('.sic-hero__doodles img');
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      imgs.forEach(function (im, i) { var d = 10 + (i % 5) * 7; im.style.translate = (x * -d).toFixed(1) + 'px ' + (y * -d).toFixed(1) + 'px'; });
    });
    hero.addEventListener('mouseleave', function () { imgs.forEach(function (im) { im.style.translate = ''; }); });
  }

  /* 4. briciole di pistacchio e ricotta al click */
  function crumbs() {
    var cols = ['#8DB043', '#A7C957', '#FFF3D6', '#C98A43', '#6E9A2E'];
    document.addEventListener('click', function (e) {
      if (reduce) return;
      for (var i = 0; i < 9; i++) {
        var d = document.createElement('span'); d.className = 'sic-crumb-fx';
        var a = Math.random() * Math.PI * 2, v = 26 + Math.random() * 46;
        d.style.left = (e.clientX - 3) + 'px'; d.style.top = (e.clientY - 3) + 'px';
        d.style.background = cols[i % cols.length];
        d.style.width = d.style.height = (4 + Math.random() * 5) + 'px';
        d.style.setProperty('--dx', (Math.cos(a) * v).toFixed(0) + 'px');
        d.style.setProperty('--dy', (Math.sin(a) * v + 40).toFixed(0) + 'px');
        document.body.appendChild(d);
        setTimeout(function (n) { return function () { n.remove(); }; }(d), 950);
      }
    });
  }


  /* 5. carosello foto delle pagine dei locali: scorre da solo, si ferma col mouse, si trascina col dito (o col mouse) */
  function carousels() {
    document.querySelectorAll('.sicb__car').forEach(function (car) {
      if (car.dataset.ready) return; car.dataset.ready = 1;
      var track = car.querySelector('.sicb__track'); if (!track) return;
      var speed = reduce ? 8 : (desktop() ? 45 : 32), acc = 0, last = 0, paused = false, hold = 0, drag = null, self = false;
      /* tutte le foto caricate subito: niente buchi bianchi quando si scorre veloce */
      track.querySelectorAll('img').forEach(function (im) { im.loading = 'eager'; im.decoding = 'async'; im.draggable = false; });
      function half() { return track.scrollWidth / 2; }
      function start() { if (Date.now() < hold) return; self = true; car.scrollLeft = half(); }
      function wrap() { var h = half(); if (h < 10) return; var x = car.scrollLeft; if (x >= h * 1.5) { self = true; car.scrollLeft = x - h; } else if (x <= h * .5) { self = true; car.scrollLeft = x + h; } }
      function tick(t) {
        var dt = last ? Math.min(.25, (t - last) / 1000) : 0; last = t;
        if (!paused && !drag && Date.now() > hold) { acc += speed * dt; var st = Math.floor(acc); if (st >= 1) { self = true; car.scrollLeft += st; acc -= st; wrap(); } }
        requestAnimationFrame(tick);
      }
      car.addEventListener('mouseenter', function () { paused = true; });
      car.addEventListener('mouseleave', function () { paused = false; drag = null; });
      car.addEventListener('touchstart', function () { hold = Date.now() + 1e9; }, { passive: true });
      car.addEventListener('touchend', function () { hold = Date.now() + 2000; }, { passive: true });
      /* mentre il dito o l'inerzia muovono il carosello, l'automatico resta fermo e non si fanno salti */
      car.addEventListener('scroll', function () { if (self) { self = false; return; } if (hold < Date.now() + 1500) hold = Date.now() + 1500; }, { passive: true });
      car.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; drag = { x: e.clientX, s: car.scrollLeft }; car.classList.add('is-drag'); e.preventDefault(); });
      window.addEventListener('pointermove', function (e) { if (!drag) return; self = true; car.scrollLeft = drag.s - (e.clientX - drag.x); });
      window.addEventListener('pointerup', function () { if (!drag) return; drag = null; car.classList.remove('is-drag'); wrap(); });
      if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
      setTimeout(start, 300);
      requestAnimationFrame(tick);
    });
  }

  function init() {
    reveal(); collect(); crumbs(); carousels();
    if (!reduce) { heroMouse(); onScroll(); window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { collect(); reveal(); onScroll(); carousels(); });
})();
